__turbopack_context__.v({
  "footer": "notifications-menu-module-scss-module__2uzzmG__footer",
  "icon_wrapper": "notifications-menu-module-scss-module__2uzzmG__icon_wrapper",
  "item": "notifications-menu-module-scss-module__2uzzmG__item",
  "item_category": "notifications-menu-module-scss-module__2uzzmG__item_category",
  "item_content": "notifications-menu-module-scss-module__2uzzmG__item_content",
  "item_text": "notifications-menu-module-scss-module__2uzzmG__item_text",
  "list": "notifications-menu-module-scss-module__2uzzmG__list",
  "mark_all": "notifications-menu-module-scss-module__2uzzmG__mark_all",
  "new": "notifications-menu-module-scss-module__2uzzmG__new",
  "new_mark": "notifications-menu-module-scss-module__2uzzmG__new_mark",
  "no_notifications": "notifications-menu-module-scss-module__2uzzmG__no_notifications",
  "no_notifications_icon": "notifications-menu-module-scss-module__2uzzmG__no_notifications_icon",
  "no_notifications_text": "notifications-menu-module-scss-module__2uzzmG__no_notifications_text",
  "no_notifications_title": "notifications-menu-module-scss-module__2uzzmG__no_notifications_title",
  "root": "notifications-menu-module-scss-module__2uzzmG__root",
  "title": "notifications-menu-module-scss-module__2uzzmG__title",
  "title_icons": "notifications-menu-module-scss-module__2uzzmG__title_icons",
});
